<template>
    <button
        :type="type"
        :class="['ui-button', buttonClasses, { 'ui-button--disabled': disabled, 'ui-button--loading': loading }]"
        :disabled="disabled"
        @click="handleClick"
    >
        <span
            v-if="$slots.icon"
            class="ui-button__icon"
        >
            <slot name="icon"></slot>
        </span>

        <span
            v-if="$slots.default"
            class="ui-button__text"
        >
            <slot></slot>
        </span>

        <span
            v-if="$slots['icon-right']"
            class="ui-button__icon"
        >
            <slot name="icon-right"></slot>
        </span>
    </button>
</template>

<script lang="ts" setup>
    import { computed, defineEmits, defineProps, PropType } from 'vue';

    const props = defineProps({
        type: {
            type: String as PropType<'button' | 'submit' | 'reset'>,
            default: 'button',
        },
        buttonType: {
            type: String as PropType<'filled' | 'outlined' | 'clear' | 'danger' | 'simple' | 'inAuction'>,
            default: 'filled',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits<{
        (e: 'clicked'): void,
    }>();

    const buttonClasses = computed(() => `ui-button--${props.buttonType}`);

    function handleClick(): void {
        if (props.loading || props.disabled) {
            return;
        }

        emit('clicked');
    }
</script>

<style lang="scss" scoped>
    @use './UISimpleButton.scss' as *;
</style>
